<template>
  <v-btn
    v-bind="$props"
    v-on="$listeners"
    icon
    plain
    @click="$emit('click:archive-item', $attrs.item)"
    >
    <slot>
    <v-icon color="blue-grey">mdi-archive</v-icon>
    </slot>
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
  name: 'ArchiveItemAction',
  extends: VBtn,
}
</script>

